import { render, staticRenderFns } from "./AddVisitPayment.vue?vue&type=template&id=64063624&scoped=true"
import script from "./AddVisitPayment.vue?vue&type=script&lang=js"
export * from "./AddVisitPayment.vue?vue&type=script&lang=js"
import style0 from "./AddVisitPayment.vue?vue&type=style&index=0&id=64063624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64063624",
  null
  
)

export default component.exports